import { render, staticRenderFns } from "./AdmPainel.vue?vue&type=template&id=59aa9376&"
import script from "./AdmPainel.vue?vue&type=script&lang=js&"
export * from "./AdmPainel.vue?vue&type=script&lang=js&"
import style0 from "./AdmPainel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports